import React, { MouseEventHandler, ReactNode } from 'react';

import NextLink from 'next/link';
import { Link as ReactLink } from 'react-router-dom';

import { appRouterPaths } from '../../constants/constants';
import useReactRouterPageCheck from '../../hooks/useReactRouterPageCheck';

interface LinkProps {
    to: string;
    style?: React.CSSProperties;
    onClick?: MouseEventHandler<HTMLElement>;
    className?: string;
    children: ReactNode;
    rel?: string;
    target?: string;
    onMouseEnter?: MouseEventHandler<HTMLElement>;
    onMouseLeave?: MouseEventHandler<HTMLElement>;
    role?: string;
    dataTestId?: string;
    id?: string;
    forceNext?: boolean;
}

const Link = ({
    to,
    children,
    style,
    onClick,
    className,
    rel,
    target,
    onMouseEnter,
    onMouseLeave,
    role,
    dataTestId,
    id,
    forceNext = false,
}: LinkProps) => {
    const isReactRouter = useReactRouterPageCheck();
    const useReactRouter =
        isReactRouter && !appRouterPaths.includes(to.split('?')[0]) && !to.includes('/markets') && !forceNext;

    if (useReactRouter) {
        return (
            <ReactLink
                to={to}
                style={style}
                onClick={onClick}
                className={className}
                onMouseEnter={onMouseEnter}
                onMouseLeave={onMouseLeave}
                rel={rel}
                target={target}
                role={role || 'link'}
                data-testid={dataTestId}
                id={id}
            >
                {children}
            </ReactLink>
        );
    }

    return (
        <NextLink
            href={to}
            style={style}
            onClick={onClick}
            className={className}
            rel={rel}
            onMouseEnter={onMouseEnter}
            onMouseLeave={onMouseLeave}
            role={role || 'link'}
            data-testid={dataTestId}
            id={id}
            prefetch={true}
        >
            {children}
        </NextLink>
    );
};

export default Link;
